module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAAL5JREFUKBVjXLttVycjEAhysDQ5Ojp+YcADmJgYGXn+//9f+u77nxsbdu4Jx6OWgQkh+V/6799/K9Zt27V33e7dmghxBAtJMUTwPwOD0/8/DBfXbd/dtX//fh6EUgZkk5GE//9nxeY0FiQlWJggp/0HOS2NkYE5DcMZWHTAhQiYzPiUmZmxOMDdZSVIB3bFjIy/GRkYJqCHPYZioKJ9QCNyglxdr8PthzKQFKNaia4QxGcBhutXYGx3o1uJTTEAp6VGdmz5croAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-arrow_1x.png
// module id = 2267
// module chunks = 0